/* eslint-disable no-underscore-dangle, no-undef, global-require */
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import axios from "axios";

import rootReducer from "../reducers";

export default (initialState = {}) => {
  const middlewares = [thunk.withExtraArgument(axios)];
  const composeEnhancers =
    (typeof window === "object" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
  const enhancers = composeEnhancers(applyMiddleware(...middlewares));
  const store = createStore(rootReducer, initialState, enhancers);
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers", () => {
      try {
        const nextReducer = require("../reducers").default;
        store.replaceReducer(nextReducer);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`==> 😭  ReduxState hot reloading error ${error}`);
      }
    });
  }

  return store;
};
/* eslint-enable no-underscore-dangle, no-undef, global-require */
